import { Moment } from "moment";
import { LookupFields, UserFields } from "src/modules/modules.type";
import { LookUpRecord, UserRecord } from "src/types/main";
import { FIELDS_TYPES } from "./type.config";

export const myTasks5WayItemsPerPage = 500;
export const myTasks5WayListName = "MyTasks5Way";
export const myTasks5WayWithRelationsListName = "MyTasks5WayRe";
export const myTasksSDCA5WayListName = "MyTasksSDCA5Way";
export const myTasks5WayCommentsListName = "MyTasks5WayComments";
export const myTask5WayCommentsFilesListName = "MyTask5WayCommentsFiles";
export const myTasks5WayEditorListName = "MyTasks5WayEditor";

export const MyTask5WayNameFields = {
  [myTasks5WayWithRelationsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Date5Way: FIELDS_TYPES.DATE,
    Date5Why: FIELDS_TYPES.DATE,
    Location: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Region: FIELDS_TYPES.LOOKUP,
    Trigger: FIELDS_TYPES.NUMBER,
    KPI: FIELDS_TYPES.LOOKUP,
    Editors: FIELDS_TYPES.STRING,
    Description: FIELDS_TYPES.STRING,
    Details: FIELDS_TYPES.STRING,
    Actions: FIELDS_TYPES.STRING,
    ProblemRepeat: FIELDS_TYPES.BOOLEAN,
    Plan: FIELDS_TYPES.CHOICE,
    Tree: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Type5Way: FIELDS_TYPES.CHOICE,
    Status: FIELDS_TYPES.LOOKUP,
    Status_x003a_Color: FIELDS_TYPES.LOOKUP,
    Escalate: FIELDS_TYPES.LOOKUP,
    AuthorEmail: FIELDS_TYPES.STRING,
    ChangeStatusDate: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
    Editor: FIELDS_TYPES.USER,
    View: FIELDS_TYPES.BOOLEAN,
    Incident: FIELDS_TYPES.LOOKUP,
    Hide: FIELDS_TYPES.BOOLEAN,
    ProblemsCount: FIELDS_TYPES.NUMBER,
    DetailsInTree: FIELDS_TYPES.STRING,
  },
  [myTasks5WayListName]: {
    ID: FIELDS_TYPES.ID,
    MOldId: FIELDS_TYPES.STRING,
    Title: FIELDS_TYPES.STRING,
    Date5Way: FIELDS_TYPES.DATE,
    Date5Why: FIELDS_TYPES.DATE,
    Location: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Region: FIELDS_TYPES.LOOKUP,
    Trigger: FIELDS_TYPES.NUMBER,
    KPI: FIELDS_TYPES.LOOKUP,
    Editors: FIELDS_TYPES.STRING,
    Description: FIELDS_TYPES.STRING,
    Details: FIELDS_TYPES.STRING,
    Actions: FIELDS_TYPES.STRING,
    ProblemRepeat: FIELDS_TYPES.BOOLEAN,
    Plan: FIELDS_TYPES.CHOICE,
    Tree: FIELDS_TYPES.STRING,
    Author: FIELDS_TYPES.USER,
    Type5Way: FIELDS_TYPES.CHOICE,
    Status: FIELDS_TYPES.LOOKUP,
    Status_x003a_Color: FIELDS_TYPES.LOOKUP,
    Escalate: FIELDS_TYPES.LOOKUP,
    AuthorEmail: FIELDS_TYPES.STRING,
    ChangeStatusDate: FIELDS_TYPES.DATE,
    Created: FIELDS_TYPES.DATE,
    Editor: FIELDS_TYPES.USER,
    View: FIELDS_TYPES.BOOLEAN,
    Incident: FIELDS_TYPES.LOOKUP,
    Hide: FIELDS_TYPES.BOOLEAN,
    ProblemsCount: FIELDS_TYPES.NUMBER,
    DetailsInTree: FIELDS_TYPES.STRING,
  },
  [myTasksSDCA5WayListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    SDCA: FIELDS_TYPES.LOOKUP,
    RootTree: FIELDS_TYPES.STRING,
    _x0035_Way: FIELDS_TYPES.LOOKUP,
  },
  [myTasks5WayCommentsListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    TextComment: FIELDS_TYPES.STRING,
    _x0035_Way: FIELDS_TYPES.LOOKUP,
    Created: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
    isRatingComment: FIELDS_TYPES.BOOLEAN,
  },
  [myTask5WayCommentsFilesListName]: {
    ID: FIELDS_TYPES.ID,
    Comment: FIELDS_TYPES.LOOKUP,
    ForHistory: FIELDS_TYPES.BOOLEAN,
    FileRef: FIELDS_TYPES.STRING,
    FileLeafRef: FIELDS_TYPES.STRING,
    UniqueId: FIELDS_TYPES.STRING,
    Name: FIELDS_TYPES.STRING,
  },
  [myTasks5WayEditorListName]: {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    _x0035_Way: FIELDS_TYPES.LOOKUP,
    Created: FIELDS_TYPES.DATE,
    Author: FIELDS_TYPES.USER,
    Location: FIELDS_TYPES.LOOKUP,
    Department: FIELDS_TYPES.LOOKUP,
    Type5Way: FIELDS_TYPES.CHOICE,
  },
};

export type MyTask5WayFieldsRecordType = {
  [myTasks5WayWithRelationsListName]: {
    ID: number;
    Title: string;
    Date5Way: Date;
    Date5Why: Date;
    Location: LookupFields;
    Department: LookupFields;
    Region: LookupFields;
    Trigger: number;
    KPI: LookupFields;
    Editors: string;
    Description: string;
    Details: string;
    Actions: string;
    ProblemRepeat: boolean;
    Plan: string;
    Tree: string;
    Author: UserFields;
    Type5Way: string;
    Status: LookupFields;
    Status_x003a_Color: LookupFields;
    Escalate: LookupFields;
    AuthorEmail: string;
    ChangeStatusDate: Date;
    Created: Date;
    Editor: UserFields;
    View: boolean;
    Incident: LookupFields;
    Hide: boolean;
    ProblemsCount: number;
    DetailsInTree: string;
  };
  [myTasks5WayListName]: {
    MOldId: string;
    ID: number;
    Title: string;
    Date5Way: Date;
    Date5Why: Date;
    Location: LookupFields;
    Department: LookupFields;
    Region: LookupFields;
    Trigger: number;
    KPI: LookupFields;
    Editors: string;
    Description: string;
    Details: string;
    Actions: string;
    ProblemRepeat: boolean;
    Plan: string;
    Tree: string;
    Author: UserFields;
    Type5Way: string;
    Status: LookupFields;
    Status_x003a_Color: LookupFields;
    Escalate: LookupFields;
    AuthorEmail: string;
    ChangeStatusDate: Date;
    Created: Date;
    Editor: UserFields;
    View: boolean;
    Incident: LookupFields;
    Hide: boolean;
    ProblemsCount: number;
    DetailsInTree: string;
  };
  [myTasksSDCA5WayListName]: {
    ID: number;
    Title: string;
    SDCA: LookupFields;
    RootTree: string;
    _x0035_Way: LookupFields;
  };
  [myTasks5WayCommentsListName]: {
    ID: number;
    Title: string;
    TextComment: string;
    _x0035_Way: LookupFields;
    Created: Date;
    Author: UserFields;
    isRatingComment: boolean;
  };
  [myTask5WayCommentsFilesListName]: {
    ID: number;
    Comment: LookupFields;
    ForHistory: boolean;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
  };
  [myTasks5WayEditorListName]: {
    ID: number;
    Title: string;
    _x0035_Way: LookupFields;
    Created: Date;
    Author: UserFields;
    Location: LookupFields;
    Department: LookupFields;
    Type5Way: string;
  };
};

export type MyTask5WayFieldsType = {
  [myTasks5WayWithRelationsListName]: {
    ID: number;
    Title: string;
    Date5Way: Moment;
    Date5Why: Moment;
    Location: LookUpRecord;
    Department: LookUpRecord;
    Region: LookUpRecord;
    Trigger: number;
    KPI: LookUpRecord;
    Editors: string;
    Description: string;
    Details: string;
    Actions: string;
    ProblemRepeat: boolean;
    Plan: string;
    Tree: string;
    Author: UserRecord;
    Type5Way: string;
    Status: LookUpRecord;
    Status_x003a_Color: LookUpRecord;
    Incident: LookUpRecord;
    Escalate: LookUpRecord;
    AuthorEmail: string;
    ChangeStatusDate: Moment;
    Created: Moment;
    Editor: UserRecord;
    View: boolean;
    Hide: boolean;
    ProblemsCount: number;
    DetailsInTree: string;
  };
  [myTasks5WayListName]: {
    MOldId: string;
    ID: number;
    Title: string;
    Date5Way: Moment;
    Date5Why: Moment;
    Location: LookUpRecord;
    Department: LookUpRecord;
    Region: LookUpRecord;
    Trigger: number;
    KPI: LookUpRecord;
    Editors: string;
    Description: string;
    Details: string;
    Actions: string;
    ProblemRepeat: boolean;
    Plan: string;
    Tree: string;
    Author: UserRecord;
    Type5Way: string;
    Status: LookUpRecord;
    Status_x003a_Color: LookUpRecord;
    Incident: LookUpRecord;
    Escalate: LookUpRecord;
    AuthorEmail: string;
    ChangeStatusDate: Moment;
    Created: Moment;
    Editor: UserRecord;
    View: boolean;
    Hide: boolean;
    ProblemsCount: number;
    DetailsInTree: string;
  };
  [myTasksSDCA5WayListName]: {
    ID: number;
    Title: string;
    SDCA: LookUpRecord;
    RootTree: string;
    _x0035_Way: LookUpRecord;
  };
  [myTasks5WayCommentsListName]: {
    ID: number;
    Title: string;
    TextComment: string;
    _x0035_Way: LookUpRecord;
    Created: Moment;
    Author: UserRecord;
    isRatingComment: boolean;
  };
  [myTask5WayCommentsFilesListName]: {
    ID: number;
    Comment: LookUpRecord;
    ForHistory: boolean;
    FileRef: string;
    FileLeafRef: string;
    UniqueId: string;
    Name: string;
  };
  [myTasks5WayEditorListName]: {
    ID: number;
    Title: string;
    _x0035_Way: LookUpRecord;
    Created: Date;
    Author: UserRecord;
    Location: LookUpRecord;
    Department: LookUpRecord;
    Type5Way: string;
  };
};
